export default __webpack_public_path__ + "static/Group 308-8168dfc6d916bc583824053513fe9587.png";